module.exports = __webpack_public_path__ + "static/img/card-paypal.550f36c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/card-paypal.png
// module id = gbyE
// module chunks = 1